var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center text-md-left" },
    [
      Math.abs(_vm.amount) >= 1.0e7
        ? _c(
            "ib-tooltip",
            {
              attrs: {
                content: `${_vm.text}: ${_vm.chartTooltipDisplay(_vm.amount)}`,
                placement: "right",
              },
            },
            [
              _c("p", { staticClass: "m-0 mb-1 amount" }, [
                _vm._v(" " + _vm._s(_vm.chartValueFormatter(_vm.amount)) + " "),
              ]),
            ]
          )
        : _c("p", { staticClass: "m-0 mb-1 amount" }, [
            _vm._v(" " + _vm._s(_vm.chartValueFormatter(_vm.amount)) + " "),
          ]),
      _c("p", { staticClass: "m-0 text-small" }, [
        _vm._v(" " + _vm._s(_vm.text) + " "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }